import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { Box, Typography, Slider } from '@mui/material'

export default function RangeSlider({
  minBound,
  maxBound,
  min,
  max,
  handleRangeChange,
  step = 1,
  minDistance = 0,
  readOnly = false,
  usePadding = false,
}) {
  const numberFormatter = new Intl.NumberFormat('it-IT')

  const [localValue, setLocalValue] = useState([min, max])

  useEffect(() => {
    setLocalValue([min, max])
  }, [min, max])

  const marks = minBound !== maxBound &&
    localValue[0] !== localValue[1] && [
      {
        value: localValue[0],
        label: usePadding
          ? `${numberFormatter.format(localValue[0])}`.padStart(6, '0')
          : numberFormatter.format(localValue[0]),
      },
      {
        value: localValue[1],
        label: usePadding
          ? `${numberFormatter.format(localValue[1])}`.padStart(6, '0')
          : numberFormatter.format(localValue[1]),
      },
    ]
  const handleChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return
    }

    if (activeThumb === 0) {
      setLocalValue([
        Math.min(newValue[0], localValue[1] - minDistance),
        localValue[1],
      ])
    } else {
      setLocalValue([
        localValue[0],
        Math.max(newValue[1], localValue[0] + minDistance),
      ])
    }
  }
  const handleChangeCommitted = (event, newValue) => {
    handleRangeChange(...localValue)
  }

  return (
    <Box sx={{ mx: 1.5 }}>
      <Box sx={{ mx: 2.5 }}>
        <Slider
          value={localValue}
          onChange={handleChange}
          onChangeCommitted={handleChangeCommitted}
          step={step}
          min={minBound !== maxBound ? minBound : 0}
          max={minBound !== maxBound ? maxBound : 10}
          disabled={minBound === maxBound || readOnly}
          valueLabelDisplay="off"
          disableSwap
        />
      </Box>
      {marks && (
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">{marks[0].label}</Typography>
          <Typography variant="body2">{marks[1].label}</Typography>
        </Box>
      )}
    </Box>
  )
}

RangeSlider.propTypes = {
  minBound: T.number.isRequired,
  maxBound: T.number.isRequired,
  min: T.number.isRequired,
  max: T.number.isRequired,
  handleRangeChange: T.func.isRequired,
  step: T.number,
  minDistance: T.number,
  readOnly: T.bool,
  usePadding: T.bool,
}
